<template>
  <td class="text-xs-center" :style="colorize()">
    <v-menu v-if="!noDetails">
      <span slot="activator">
        <minute :value="minutes"></minute>
      </span>
      <v-list>
        <v-list-tile v-for="(availability, i) in availabilities" :key="i">
          <v-list-tile-title>
            {{ scheduleToStr(availability.from) }}
            <v-icon>chevron_right</v-icon>
            {{ scheduleToStr(availability.to) }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </td>
</template>

<script>
  import { Minute } from '@/components/formatters'
  export default {
    components: {
      Minute
    },
    props: {
      availabilities: {
        type: Array,
        required: true
      },
      maxHours: {
        type: Number,
        required: true
      },
      noDetails: {
        type: Boolean,
        default: false
      },
      color: {
        type: Object,
        default: () => ({
          r: 104,
          g: 184,
          b: 107
        })
      }
    },
    computed: {
      minutes () {
        return this.availabilities
          .reduce((sum, value) => sum + (value.to - value.from) / 1000, 0)
      }
    },
    methods: {
      colorize () {
        const percent = (this.minutes / 60 / 60) / this.maxHours
        return { background: `rgba(${this.color.r}, ${this.color.g}, ${this.color.b}, ${percent})` }
      },
      scheduleToStr (date) {
        return [
          `0${date.getHours()}`.substr(-2),
          `0${date.getMinutes()}`.substr(-2)
        ].join(':')
      }
    }
  }
</script>


<style lang="stylus" scoped>
  @import "../../variables"

  td {
    border: 1px solid $material-twelve-percent-dark;
    padding: 0;
    position: relative;

    &:hover span, &:hover .card {
      opacity: 1;
    }

    span, .card {
      transition: all 300ms;
      opacity: 0;
    }

    .card {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/availabilities/AvailabilityCell.vue